import React from 'react';
import { Box } from '@mui/material';

const CustomInterpreterTabPanel = ({ children, value, index }) => {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
        >
            {value === index && <Box>{children}</Box>}
        </Box>
    );
};

export default CustomInterpreterTabPanel;
